export const FinishResume = () => (
  <svg
    width="120"
    height="120"
    viewBox="0 0 120 120"
    xmlns="http://www.w3.org/2000/svg"
    style={{ display: 'block' }}
  >
    <path
      d="M60 120.409C93.1371 120.409 120 93.5458 120 60.4087C120 27.2716 93.1371 0.408691 60 0.408691C26.8629 0.408691 0 27.2716 0 60.4087C0 93.5458 26.8629 120.409 60 120.409Z"
      fill="#D8D0FA"
    />
    <mask
      id="mask0_2733_100302"
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="120"
      height="121"
    >
      <path
        d="M60 120.409C93.1371 120.409 120 93.5458 120 60.4087C120 27.2716 93.1371 0.408691 60 0.408691C26.8629 0.408691 0 27.2716 0 60.4087C0 93.5458 26.8629 120.409 60 120.409Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask0_2733_100302)">
      <path
        d="M87.28 28.4087H32.71C26.0825 28.4087 20.71 33.7813 20.71 40.4087V116.409C20.71 123.036 26.0825 128.409 32.71 128.409H87.28C93.9074 128.409 99.28 123.036 99.28 116.409V40.4087C99.28 33.7813 93.9074 28.4087 87.28 28.4087Z"
        fill="white"
      />
    </g>
    <path
      d="M85.5999 35.7485H34.4799C30.7189 35.7485 27.6699 38.7975 27.6699 42.5585V53.5985C27.6699 57.3596 30.7189 60.4085 34.4799 60.4085H85.5999C89.361 60.4085 92.4099 57.3596 92.4099 53.5985V42.5585C92.4099 38.7975 89.361 35.7485 85.5999 35.7485Z"
      fill="#051A49"
    />
    <mask
      id="mask1_2733_100302"
      maskUnits="userSpaceOnUse"
      x="27"
      y="35"
      width="66"
      height="26"
    >
      <path
        d="M85.5999 35.7485H34.4799C30.7189 35.7485 27.6699 38.7975 27.6699 42.5585V53.5985C27.6699 57.3596 30.7189 60.4085 34.4799 60.4085H85.5999C89.361 60.4085 92.4099 57.3596 92.4099 53.5985V42.5585C92.4099 38.7975 89.361 35.7485 85.5999 35.7485Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask1_2733_100302)">
      <path
        d="M92.41 35.7985V51.1585C83.92 51.1585 77 44.2885 77 35.7485H92.41V35.8085V35.7985Z"
        fill="#E60278"
      />
    </g>
    <path
      d="M65.1499 49.3488V41.2988C69.6099 41.2988 73.2399 44.8988 73.2399 49.3788H65.1499V49.3488Z"
      fill="#0D3880"
    />
    <path
      d="M86.25 60.4088C86.25 56.1788 82.85 52.7788 78.62 52.7788C74.39 52.7788 70.98 56.1788 70.98 60.4088H76.07C76.07 59.0088 77.22 57.8688 78.62 57.8688C80.02 57.8688 81.16 59.0088 81.16 60.4088H86.25Z"
      fill="#E60278"
    />
    <path
      d="M99.8499 69.2988H21.4699C17.7089 69.2988 14.6599 72.3478 14.6599 76.1088V89.7488C14.6599 93.5099 17.7089 96.5588 21.4699 96.5588H99.8499C103.611 96.5588 106.66 93.5099 106.66 89.7488V76.1088C106.66 72.3478 103.611 69.2988 99.8499 69.2988Z"
      fill="#937FEF"
    />
    <path
      d="M45.3301 79.5288H96.4401"
      stroke="white"
      strokeWidth="2.56"
      strokeMiterlimit="10"
      strokeLinecap="round"
    />
    <path
      d="M45.3301 86.3389H96.4401"
      stroke="white"
      strokeWidth="2.56"
      strokeMiterlimit="10"
      strokeLinecap="round"
    />
    <path
      d="M34.4101 74.4888H25.8901C24.4401 74.4888 23.3301 75.5988 23.3301 77.0488V88.9788C23.3301 90.4288 24.4401 91.5388 25.8901 91.5388H34.4101C35.8601 91.5388 36.9701 90.4288 36.9701 88.9788V77.0488C36.9701 75.5988 35.8601 74.4888 34.4101 74.4888Z"
      fill="#051A49"
    />
    <path
      d="M28.45 81.3087C29.3889 81.3087 30.15 80.5476 30.15 79.6087C30.15 78.6698 29.3889 77.9087 28.45 77.9087C27.5111 77.9087 26.75 78.6698 26.75 79.6087C26.75 80.5476 27.5111 81.3087 28.45 81.3087Z"
      fill="white"
    />
    <path
      d="M32.7 83.0088H27.59C27.08 83.0088 26.74 83.3488 26.74 83.8588C26.74 84.3688 27.08 84.7088 27.59 84.7088H32.7C33.21 84.7088 33.55 84.3688 33.55 83.8588C33.55 83.3488 33.21 83.0088 32.7 83.0088ZM31 86.4188H27.59C27.08 86.4188 26.74 86.7588 26.74 87.2688C26.74 87.7788 27.08 88.1188 27.59 88.1188H31C31.51 88.1188 31.85 87.7788 31.85 87.2688C31.85 86.7588 31.51 86.4188 31 86.4188Z"
      fill="white"
    />
  </svg>
);
